export const chunkSizeMins = 15;
export const chunkHeightPx = 35;
